exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1D3SjAfUzJsGtFv085pot8{display:-webkit-box;display:-ms-flexbox;display:flex;display:-webkit-flex;max-width:510px}html[dir] ._1D3SjAfUzJsGtFv085pot8{margin:30px}", ""]);
// Exports
exports.locals = {
	"divContainer": "_1D3SjAfUzJsGtFv085pot8"
};